import { useState, FormEvent } from 'react';
import { supabase } from '../../../lib/supabase';

const ContactForm = () => {
  const [status, setStatus] = useState<'idle' | 'sending' | 'ok' | 'error'>('idle');
  const [errorDetail, setErrorDetail] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    setErrorDetail('');
    const form = e.currentTarget;
    const fd = new FormData(form);

    const nombre = (fd.get('nombre') as string)?.trim();
    const telefono = (fd.get('telefono') as string)?.trim();
    const email = (fd.get('email') as string)?.trim();
    const servicio = (fd.get('servicio') as string)?.trim();
    const vehiculo = (fd.get('vehiculo') as string)?.trim();
    const mensaje = (fd.get('mensaje') as string)?.trim();

    const mensajeFinal = vehiculo ? `Vehículo: ${vehiculo}\n\n${mensaje}` : mensaje;

    try {
      const { error } = await supabase
        .from('TALLERMECANICOKEVIN_contact_messages')
        .insert({ nombre, telefono, email, servicio: servicio || null, mensaje: mensajeFinal });

      if (error) {
        setErrorDetail(error.message);
        setStatus('error');
      } else {
        setStatus('ok');
        form.reset();
      }
    } catch (err) {
      setErrorDetail(String(err));
      setStatus('error');
    }
  };

  if (status === 'ok') {
    return (
      <div className="flex flex-col items-center justify-center py-12 gap-3">
        <div className="w-14 h-14 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-2xl">
          <i className="ri-check-double-line" />
        </div>
        <p className="text-white font-bold text-base">¡Mensaje enviado!</p>
        <p className="text-zinc-500 text-sm text-center">Te contactaremos en menos de 24 horas.</p>
        <button
          onClick={() => setStatus('idle')}
          className="mt-2 text-xs text-yellow-400 hover:text-white transition-colors cursor-pointer uppercase tracking-widest"
        >
          Enviar otro mensaje
        </button>
      </div>
    );
  }

  return (
    <>
      <h2 className="text-white font-black text-lg uppercase mb-1">Pide tu presupuesto</h2>
      <p className="text-zinc-500 text-sm mb-6">Cuéntanos qué le pasa a tu vehículo y te respondemos en menos de 24h.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Nombre *</label>
            <input name="nombre" required placeholder="Tu nombre" className="w-full bg-zinc-800 border border-zinc-700 text-white text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors placeholder:text-zinc-600" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Teléfono *</label>
            <input name="telefono" required type="tel" placeholder="6XX XXX XXX" className="w-full bg-zinc-800 border border-zinc-700 text-white text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors placeholder:text-zinc-600" />
          </div>
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Email</label>
          <input name="email" type="email" placeholder="tu@email.com" className="w-full bg-zinc-800 border border-zinc-700 text-white text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors placeholder:text-zinc-600" />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Vehículo</label>
          <input name="vehiculo" placeholder="Marca, modelo y año" className="w-full bg-zinc-800 border border-zinc-700 text-white text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors placeholder:text-zinc-600" />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Servicio</label>
          <select name="servicio" className="w-full bg-zinc-800 border border-zinc-700 text-zinc-400 text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors cursor-pointer">
            <option value="">Selecciona un servicio</option>
            <option>Revisión periódica</option>
            <option>Diagnóstico electrónico</option>
            <option>Frenos y suspensión</option>
            <option>Chapa y pintura</option>
            <option>Climatización</option>
            <option>Compraventa de vehículo</option>
            <option>Otro</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1.5">Mensaje *</label>
          <textarea name="mensaje" required maxLength={500} rows={4} placeholder="Describe la avería o consulta..." className="w-full bg-zinc-800 border border-zinc-700 text-white text-sm px-4 py-2.5 outline-none focus:border-yellow-400/50 transition-colors resize-none placeholder:text-zinc-600" />
        </div>
        {status === 'error' && (
          <div className="bg-red-500/10 border border-red-500/20 px-4 py-3">
            <p className="text-red-400 text-xs font-bold mb-0.5">Error al enviar el mensaje</p>
            {errorDetail && <p className="text-red-400/70 text-[11px]">{errorDetail}</p>}
            <p className="text-red-400/70 text-[11px] mt-1">Inténtalo de nuevo o llámanos directamente.</p>
          </div>
        )}
        <button
          type="submit"
          disabled={status === 'sending'}
          className="w-full flex items-center justify-center gap-2 bg-yellow-400 text-black font-black text-xs uppercase tracking-widest py-3.5 hover:bg-yellow-300 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap"
        >
          {status === 'sending' ? (
            <><i className="ri-loader-4-line animate-spin" /> Enviando...</>
          ) : (
            <><i className="ri-send-plane-line" /> Enviar mensaje</>
          )}
        </button>
      </form>
    </>
  );
};

export default ContactForm;
